import React, { useState, useEffect, useMemo, useCallback } from 'react'

import {
    getQueryValue,
    IsChainPal,
    IsWeChat,
    openApp,
    UAPlatform,
    navigatorLanguage,
} from '../../util'
import WXModel from '../../components/common/wx-modal'
import { useTranslation } from 'react-i18next'
import './index.less'
import '../../i18n'

function App({ toUrl }) {
    const { t, i18n } = useTranslation()
    const [lang] = useState(navigatorLanguage)
    const [urlStr] = useState(getQueryValue('url'))
    console.log(urlStr)
    const [iframeSrc, setIframeSrc] = useState('')

    const [isShowWXTip, setIsShowWXTip] = useState(false)
    const [isShowDownload, setIsShowDownload] = useState(false)

    useEffect(() => {
        i18n.changeLanguage(lang)
    }, [i18n, lang])

    const getHost = useMemo(() => {
        return url => {
            try {
                return new URL(url).host
            } catch (error) {
                console.log(error)
                return url
            }
        }
    }, [])
    console.log(toUrl)
    useEffect(() => {
        let url = (toUrl || 'https://chainpal.tongfudun.com') + window.location.hash
        if (!(url.indexOf('http') > -1 || url.indexOf('https') > -1)) {
            url = 'https://chainpal.tongfudun.com'
        }
        // 若app 打开,和自己的内部网站（已经接入app打开方法），直接采用app webView 打开
        let myHost = getHost(url)
        if (IsChainPal || (myHost.indexOf('tongfudun.com') > -1 && toUrl)) {
            window.location.href = url
        }
        setIframeSrc(url)
    }, [t, urlStr, getHost, lang])

    const handlerOpen = useCallback(() => {
        // 微信打开
        if (IsWeChat) {
            setIsShowWXTip(true)
            return
        }
        let openUrl =
            UAPlatform === 'pc'
                ? 'chainpalpc://dtcmessenger.tongfudun.com'
                : 'dtcmessenger://dtcmessenger.tongfudun.com'
        openApp(`${openUrl}/openUrl?url=${toUrl}`, e => {
            setIsShowDownload(e)
        })
    }, [iframeSrc])

    return (
        <div className="web3-view">
            {/* 微信中弹层提示浏览器打开 */}
            {IsWeChat && isShowWXTip ? <WXModel></WXModel> : ''}
            <div className="web3-iframe-wrap">
                <iframe
                    src={iframeSrc}
                    title="chainpal"
                    frame-border="no"
                    sandbox="allow-forms allow-scripts allow-popups allow-modals allow-same-origin"
                ></iframe>
            </div>
            <div className="app-entry-btn" onClick={handlerOpen}>
                {t('open-app')}
            </div>
        </div>
    )
}

export default App
